import React from 'react'
import '../Styles/Section3.css'
// import { useNavigate } from 'react-router-dom'

export default function Section3() {
    // const navigate = useNavigate();
    const navigatetofacilities = ()=>{
        window.location.href = `/facilities`;
        // navigate('/facilities');
    }
  return (
    <div className='section3' id='facilities'>
        <div className="sec3container">
            <div className="sec3head">FACILITIES</div>
            <div className="sec3boxcontainer">
                <div className="sec3box">
                    <p className="sec3boxhead">Cultural Activities</p>
                    <p className="sec3boxpara">Our college provides a platform for students to showcase their talents and creativity, enabling them to express themselves in unique and meaningful ways. </p>
                    <p className="sec3boxbtn" onClick={navigatetofacilities}>Read More</p>
                </div>
                <div className="sec3box">
                    <p className="sec3boxhead">Sports Activities</p>
                    <p className="sec3boxpara">At our college, we offer a variety of sports and fitness programs, including intramural and intercollegiate sports to cater to the interests and needs of all students. </p>
                    <p className="sec3boxbtn" onClick={navigatetofacilities}>Read More</p>
                </div>
                <div className="sec3box">
                    <p className="sec3boxhead">PD Programs</p>
                    <p className="sec3boxpara">PD programs are a vital aspect of college life, providing students with opportunities to develop their skills, knowledge, and competencies beyond the academic curriculum. </p>
                    <p className="sec3boxbtn" onClick={navigatetofacilities}>Read More</p>
                </div>
                <div className="sec3box">
                    <p className="sec3boxhead">Smart Classes</p>
                    <p className="sec3boxpara">Smart classes are a revolutionary addition to the modern-day education system, providing students with a more interactive, engaging, and dynamic learning experience.</p>
                    <p className="sec3boxbtn" onClick={navigatetofacilities}>Read More</p>
                </div>
                <div className="sec3box">
                    <p className="sec3boxhead">Picnic Tour</p>
                    <p className="sec3boxpara">Our College Picnic tours which are a popular recreational activity for students, providing an opportunity to unwind, relax, and have fun outside the classroom.</p>
                    <p className="sec3boxbtn" onClick={navigatetofacilities}>Read More</p>
                </div>
                <div className="sec3box">
                    <p className="sec3boxhead">Seminar and Webinar</p>
                    <p className="sec3boxpara">Seminars and webinars are a popular academic discourse in colleges, providing students with opportunities to engage in discussions, and learn from experts in their field.</p>
                    <p className="sec3boxbtn" onClick={navigatetofacilities}>Read More</p>
                </div>
            </div>
        </div>
    </div>
  )
}
